import React, { useState, useEffect } from "react";
import Select from "react-select";
import { OptionType, AccountFormType } from "../utils/GeneBoxAPI";
import { Controller, Control } from "react-hook-form";

interface IProps {
    type: string;
    control: Control<AccountFormType>;
    options: OptionType[];
    setValue?: any;
    getValues: any;
}

const MultiSelect = ({
    type,
    options,
    control,
    setValue,
    getValues,
}: IProps) => {
    const [selectedAll, setSelectedAll] = useState(false);

    const onChangeAll = () => {
        const newOptions = selectedAll ? [] : options;
        setValue(type, newOptions);
        setSelectedAll(!selectedAll);
    };

    const onChangeSelect = (value: any) =>{
        setValue(type, value);
        setSelectedAll(value.length === options.length);
    }
    useEffect(() => {
        const value = getValues(type);
        if (value.length !== 0 && value.length === options.length) {
            setSelectedAll(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <div className="dialog_form_item">
                <label className="dialog_label">
                    {type === "download" ? "下載報告權限" : "查看報告權限"}
                </label>
                <div className="dialog_select">
                    <Controller
                        render={({ field }) => (
                            <Select
                                {...field}
                                options={options}
                                isMulti
                                closeMenuOnSelect={false}
                                placeholder="請選擇權限"
                                onChange={onChangeSelect}
                            />
                        )}
                        control={control}
                        name={type}
                    />
                    <span>
                        <input
                            type="checkbox"
                            id={type}
                            checked={selectedAll}
                            onChange={onChangeAll}
                        />
                        <label htmlFor={type}>全選</label>
                    </span>
                </div>
            </div>
        </>
    );
};

export default MultiSelect;
